import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <div className="footer">
      {/* <div className="footerSNSBox">
        <div>SNS</div>
        <div>SNS</div>
        <div>SNS</div>
      </div> */}
      <div className="footerInfoBox">
        <div className="footerInfoTextBox">
          <span className="footerInfoPointText">상호</span>
          <span className="footerInfoNomalText">남산웍스</span>
          <span className="footerInfoPointText">대표자</span>
          <span className="footerInfoNomalText">백승철</span>
        </div>
        <div className="footerInfoTextBox">
          <span className="footerInfoPointText">사업자등록번호</span>
          <span className="footerInfoNomalText">172-15-01875</span>
        </div>

        {/* <div className="footerInfoTextBox"> */}
        {/* <span className="footerInfoPointText">주소</span>
          <span className="footerInfoNomalText">
            서울특별시 강서구 강서로 56가길 69, 4층
          </span> */}
        {/* </div> */}
        <div className="footerInfoTextBox">
          {/* <span className="footerInfoPointText">전화</span>
          <span className="footerInfoNomalText">000-0000-0000</span> */}
          <span className="footerInfoPointText">E-mail</span>
          <span className="footerInfoNomalText">boboworks@naver.com</span>
        </div>
      </div>
      <div className="footerBottom">
        <div>ⓒ Copyright 2022 NamsanWorks all right reserved</div>
      </div>
    </div>
  );
};

export default Footer;
